









import { Vue, Prop, Watch, Component } from "vue-property-decorator";

@Component( {
    name: "Template",
    props: {},
    components: {

    }
} )
export default class Template extends Vue {

    constructor() {
        super();
    }

    public mounted() {

    }
}
